import { atom } from 'jotai';

export const selectedSourceDataAtom = atom({});
selectedSourceDataAtom.debugLabel = 'selectedSourceData';

export default { selectedSourceDataAtom };
